import { useEffect } from 'react';

import {
  useGetUserAssetsQuery,
  useGetUserProgramsQuery,
} from 'shared/api/retail';
import { AuthService } from 'shared/lib/keycloak';
import { useAppDispatch } from 'shared/lib/redux';
import { useAnimatedMounting } from 'shared/lib/utils';
import { MODAL_ANIMATION_DURATION } from 'shared/config/constants';
import { Alert, ALERT_VARIANT } from 'shared/ui/alert';

import {
  setIsAcceptedInviteAlertVisible,
  useAcceptedInviteAlertVariantSelector,
  useAcceptedInviteMessageSelector,
} from './model';
import { ACCEPTED_INVITE_ALERT_CLOSE_TIMEOUT } from './constants';

export const AcceptedInviteAlert = () => {
  const message = useAcceptedInviteMessageSelector();
  const alertVariant = useAcceptedInviteAlertVariantSelector();

  const dispatch = useAppDispatch();

  const teacherBk = AuthService.getUserBk();

  const { data: userAssets } = useGetUserAssetsQuery(teacherBk);
  const { data: userPrograms } = useGetUserProgramsQuery(teacherBk);

  const handleAlertClose = () => {
    const hasNoUserPrograms = !userPrograms?.length;
    const hasNoUserAssets = !userAssets?.length;

    const hasNoEntitlements = hasNoUserPrograms || hasNoUserAssets;

    if (hasNoEntitlements && alertVariant === ALERT_VARIANT.SUCCESS) {
      window.location.reload();
    }

    dispatch(setIsAcceptedInviteAlertVisible(false));
  };

  const { isMounted, handleAnimatedUnmount } = useAnimatedMounting(
    handleAlertClose,
    MODAL_ANIMATION_DURATION,
  );

  useEffect(() => {
    const alertCloseTimeout = setTimeout(
      handleAnimatedUnmount,
      ACCEPTED_INVITE_ALERT_CLOSE_TIMEOUT,
    );

    return () => {
      clearTimeout(alertCloseTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Alert
      variant={alertVariant}
      onClose={handleAnimatedUnmount}
      isVisible={isMounted}
    >
      {message}
    </Alert>
  );
};
